import { renderCartDrawer, renderCartPage } from '@theme/utils';

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    this.discountInput = null;
    this.discountAddButton = null;
    this.discountRemove = null;
    this.isLoading = false;
  }

  connectedCallback() {
    this.cacheDomElements();
    this.setupEventListeners();
  }

  cacheDomElements() {
    this.discountInput = this.querySelector('[js-discount-code="input"]');
    this.discountAddButton = this.querySelector('[js-discount-code="add"]');
    this.discountRemove = this.querySelectorAll('[js-discount-code="remove"]');
  }

  setupEventListeners() {
    this.discountInput?.addEventListener('keydown', this.handleDiscountInput.bind(this));
    this.discountAddButton?.addEventListener('click', this.handleDiscountAdd.bind(this));

    this.discountRemove?.forEach(button => {
      button.addEventListener('click', this.handleDiscountRemove.bind(this));
    });
  }

  setLoadingState(isLoading) {
    this.isLoading = isLoading;

    if (this.discountInput) {
      this.discountInput.disabled = isLoading;
    }

    if (this.discountAddButton) {
      this.discountAddButton.disabled = isLoading;
    }

    if (isLoading) {
      this.classList.add('is-loading');
    } else {
      this.classList.remove('is-loading');
    }
  }

  async handleDiscountAdd() {
    if (!this.discountInput || !this.discountInput.value.trim()) {
      return;
    }

    const discount = this.discountInput.value.trim();
    await this.updateCart(discount);
  }

  async handleDiscountRemove(event) {
    const existingDiscounts = this.dataset.existingDiscounts;

    if (!existingDiscounts) {
      console.error('No existing discounts found');
      return;
    }

    const discountToRemove = event.currentTarget.dataset.discountApplicationTitle;
    const newDiscounts = existingDiscounts.split(',').filter(discount => discount !== discountToRemove).join(',');

    this.deleteCookie('discount_code');
    await this.updateCart(newDiscounts);
  }

  async handleDiscountInput(event) {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();

    if (!this.discountInput || !this.discountInput.value.trim()) {
      return;
    }

    const discount = this.discountInput.value.trim();
    await this.updateCart(discount);
  }

  async updateCart(discount) {
    if (this.isLoading) {
      return;
    }

    this.setLoadingState(true);

    try {
      const sectionName = this.getSectionName();

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: discount,
          sections: sectionName
        })
      }).then(res => res.json());

      this.renderSection(response.sections[sectionName], sectionName);

      if (this.discountInput) {
        this.discountInput.value = '';
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  getSectionName() {
    if (this.closest('cart-drawer')) {
      return 'cart-drawer';
    }

    return 'cart';
  }

  renderSection(markup, sectionName) {
    if (!markup) {
      return;
    }

    if (sectionName === 'cart-drawer') {
      renderCartDrawer(markup);
    } else {
      renderCartPage(markup);
    }
  }

  deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}

customElements.define('discount-code', DiscountCode);

